import {
  HorizontalTabs,
  HorizontalTabsButton,
  HorizontalTabsList,
  HorizontalTabsPanel,
} from '@cinch-labs/design-system'
import cx from 'classnames'
import React from 'react'

import styles from './tabs.module.css'

export type TabsProps = {
  content: TabProps[]
  ariaLabel: string
}

export type TabProps = {
  label: string
  onTabClick?: () => void
  panelContent: React.ReactNode
}

export const Tabs: React.FC<TabsProps> = ({ content, ariaLabel }) => {
  if (content.length === 0) return null

  return (
    <HorizontalTabs activeTabId="tab-1" className={styles.tabsList}>
      <HorizontalTabsList
        ariaLabel={ariaLabel}
        className={styles.tabButtonList}
      >
        {content.map((tab, index) => {
          const tabOrderNumber = index + 1
          return (
            <HorizontalTabsButton
              key={`tab-${tabOrderNumber}`}
              id={`tab-${tabOrderNumber}`}
              panelId={`tabpanel-${tabOrderNumber}`}
              className={cx(styles.tabButton, {
                [styles.tabButtonLeft]: tabOrderNumber === 1,
                [styles.tabButtonRight]: tabOrderNumber === content.length,
              })}
              onButtonClick={() => tab.onTabClick?.()}
            >
              {tab.label}
            </HorizontalTabsButton>
          )
        })}
      </HorizontalTabsList>
      {content.map((tab, index) => {
        const tabOrderNumber = index + 1
        return (
          <HorizontalTabsPanel
            key={`tabpanel-${tabOrderNumber}`}
            id={`tabpanel-${tabOrderNumber}`}
            buttonId={`tab-${tabOrderNumber}`}
            className={styles.tabPanel}
          >
            {tab.panelContent}
          </HorizontalTabsPanel>
        )
      })}
    </HorizontalTabs>
  )
}
